import { MetabaseAnalyticsModule, PageHeader } from '@korint/folio';

export default function MetabaseAnalytics() {
  return (
    <div>
      <PageHeader title="Statistiques" />
      <MetabaseAnalyticsModule />
    </div>
  );
}
